<script setup lang="ts">
import { SelectOption } from "@/models/frontend-only/SelectOption";

const liturgy = useLiturgyStore();
const { t } = useI18n();

const massSetting = ref("");
const props = defineProps<{
  enableSeeAll?: boolean;
}>();

onMounted(() => {
  if (!liturgy.availableMassSettings) {
    liturgy.getHomeData(null, 0);
  }
});

function onSelectMassSetting() {
  if (!massSetting.value) {
    return;
  }

  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).dataLayer.push({
    event: "selectMassSetting",
    mass_setting: massSetting.value,
  });

  // Clear out event variable
  (window as any).dataLayer.push({
    mass_setting: undefined,
  });

  const params = new URLSearchParams();
  if (massSetting.value === "See All") {
    params.append("search", `\"Mass Setting\"`);
  } else {
    params.append("search", `\"Mass Setting\" \"${massSetting.value}\"`);
  }
  params.append("sortBy", "title");
  params.append("seo", "MassSettings");
  if (massSetting.value !== "See All") {
    params.append("seotitle", massSetting.value);
  }

  router.push(`/search/results?${params.toString()}`);
}

const availableMassSettingCategories = computed<SelectOption[]>(() => {
  if (!liturgy.availableMassSettings?.length) {
    return [];
  }

  const options: SelectOption[] = [];
  options.push({
    value: "",
    label: t("SV.LIT_SelectMassSetting") + " ...",
  });

  if (props.enableSeeAll) {
    options.push({
      value: "See All",
      label: t("SV.LIT_SeeAll"),
    });
  }

  options.push(
    ...liturgy.availableMassSettings.map((c: string) => ({
      value: c,
      label: c,
    })),
  );
  return options;
});
</script>

<template>
  <FormSelect
    v-if="availableMassSettingCategories.length"
    v-model="massSetting"
    :options="availableMassSettingCategories"
    :label="$t('SV.LIT_SelectMassSetting')"
    hide-label
    class="select-mass-settings-btn"
    @change="onSelectMassSetting"
  />
</template>

<style scoped lang="postcss"></style>
